__turbopack_context__.v({
  "headlineAnchor": "PeopleHeroTicker-module-scss-module__zYisRa__headlineAnchor",
  "headlineFade": "PeopleHeroTicker-module-scss-module__zYisRa__headlineFade",
  "headlineItem": "PeopleHeroTicker-module-scss-module__zYisRa__headlineItem",
  "headlineItem--active": "PeopleHeroTicker-module-scss-module__zYisRa__headlineItem--active",
  "headlineTrack": "PeopleHeroTicker-module-scss-module__zYisRa__headlineTrack",
  "headlineViewport": "PeopleHeroTicker-module-scss-module__zYisRa__headlineViewport",
  "stack-module-0": "PeopleHeroTicker-module-scss-module__zYisRa__stack-module-0",
  "stack-module-1": "PeopleHeroTicker-module-scss-module__zYisRa__stack-module-1",
  "stack-module-10": "PeopleHeroTicker-module-scss-module__zYisRa__stack-module-10",
  "stack-module-11": "PeopleHeroTicker-module-scss-module__zYisRa__stack-module-11",
  "stack-module-12": "PeopleHeroTicker-module-scss-module__zYisRa__stack-module-12",
  "stack-module-13": "PeopleHeroTicker-module-scss-module__zYisRa__stack-module-13",
  "stack-module-14": "PeopleHeroTicker-module-scss-module__zYisRa__stack-module-14",
  "stack-module-15": "PeopleHeroTicker-module-scss-module__zYisRa__stack-module-15",
  "stack-module-16": "PeopleHeroTicker-module-scss-module__zYisRa__stack-module-16",
  "stack-module-17": "PeopleHeroTicker-module-scss-module__zYisRa__stack-module-17",
  "stack-module-18": "PeopleHeroTicker-module-scss-module__zYisRa__stack-module-18",
  "stack-module-19": "PeopleHeroTicker-module-scss-module__zYisRa__stack-module-19",
  "stack-module-2": "PeopleHeroTicker-module-scss-module__zYisRa__stack-module-2",
  "stack-module-20": "PeopleHeroTicker-module-scss-module__zYisRa__stack-module-20",
  "stack-module-3": "PeopleHeroTicker-module-scss-module__zYisRa__stack-module-3",
  "stack-module-4": "PeopleHeroTicker-module-scss-module__zYisRa__stack-module-4",
  "stack-module-5": "PeopleHeroTicker-module-scss-module__zYisRa__stack-module-5",
  "stack-module-6": "PeopleHeroTicker-module-scss-module__zYisRa__stack-module-6",
  "stack-module-7": "PeopleHeroTicker-module-scss-module__zYisRa__stack-module-7",
  "stack-module-8": "PeopleHeroTicker-module-scss-module__zYisRa__stack-module-8",
  "stack-module-9": "PeopleHeroTicker-module-scss-module__zYisRa__stack-module-9",
  "z-base": "PeopleHeroTicker-module-scss-module__zYisRa__z-base",
  "z-content": "PeopleHeroTicker-module-scss-module__zYisRa__z-content",
  "z-footer": "PeopleHeroTicker-module-scss-module__zYisRa__z-footer",
  "z-header": "PeopleHeroTicker-module-scss-module__zYisRa__z-header",
  "z-hero": "PeopleHeroTicker-module-scss-module__zYisRa__z-hero",
  "z-logo": "PeopleHeroTicker-module-scss-module__zYisRa__z-logo",
  "z-logo-effect": "PeopleHeroTicker-module-scss-module__zYisRa__z-logo-effect",
  "z-navigation": "PeopleHeroTicker-module-scss-module__zYisRa__z-navigation",
  "z-sub": "PeopleHeroTicker-module-scss-module__zYisRa__z-sub",
});
